/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { app_v1_settings_AuthAppSettings } from './app_v1_settings_AuthAppSettings';
import type { app_v1_settings_ModulesAppSettings } from './app_v1_settings_ModulesAppSettings';
export type app_v1_settings_AppSettings = {
    app_enabled?: boolean;
    app_language?: app_v1_settings_AppSettings.app_language;
    app_logo?: string;
    app_name?: string;
    auth?: app_v1_settings_AuthAppSettings;
    is_test_bank_id?: boolean;
    modules?: app_v1_settings_ModulesAppSettings;
    theme?: string;
};
export namespace app_v1_settings_AppSettings {
    export enum app_language {
        EN = 'en',
        SV = 'sv',
    }
}

